import React from 'react';
import Checkbox from '../../../../../core/controls/checkbox/Checkbox';
import { combineClassNames } from '../../../../../core/css';
import { withTranslate } from '../../../../../core/translate';

const CompareSorting = ({
  className,
  activeIndex,
  translate,
  onSort,
  columnIndex,
  isSorted = false,
  analyticsKey,
  hideFromTab = false,
  headers,
}) => {
  // TODO: Don't use Radio component, remove el prop from Radio component. (Use Checkbox component)
  return (
    <Checkbox
      analyticsKey={analyticsKey}
      tabIndex={hideFromTab ? '-1' : '0'}
      aria-hidden={hideFromTab ? 'true' : 'false'}
      customModifier="compare-sorting"
      className={combineClassNames(className)}
      checked={isSorted}
      onChange={() => onSort(activeIndex, columnIndex)}
      ariaLabel={translate('compare.sorting.control.aria.v3', {
        primaryText: headers[activeIndex]?.primaryText,
      })}>
      {translate('compare.column.sorting.label.v3')}
    </Checkbox>
  );
};

export default withTranslate(CompareSorting);
